<a href={urlFor.genre(genre)}>{truncatedTitle}</a>

<style lang="stylus">
  a
    font-size: 12px
    text-decoration: none
    display: inline-block
    margin: 8px 8px 0 0
    color: $violet
    border: 1px solid
    border-radius: 4px
    padding: 6px 12px

    @media $bp.desktop
      &:hover
        color: darken($violet, 25%)
</style>

<script>
  import * as urlFor from '../helpers/urlFor';
  import truncateGenreTitle from '../helpers/truncateGenreTitle';

  export let genre;

  $: truncatedTitle = truncateGenreTitle(genre.title);
</script>
